<div class="field">
    <span class="field-title">Corredora del vendedor<span class="asterisk">*</span></span>
    <select-input class="input" [placeHolder]="'Corredora del vendedor'" [value]="getBrokerSellerSelected()"
        [OBJECT]="brokers" [doFilterObject]="true" [array]="arrayBrokers" [identificatorSearch]="'buyer'"
        (valueOut)="setValueWithEvent($event)"></select-input>
</div>